import * as React from "react";

export default function InfoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 13 13">
      <path
        stroke="#F8746B"
        strokeLinecap="round"
        d="M6.551 8.75v-.1M6.551 8.75v-.1M6.551 6.55v-2.3M6.551 6.55v-2.3"
      ></path>
      <path
        stroke="#F8746B"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0"
      ></path>
    </svg>
  );
}
